import { IBreadCrumbItem } from "@kernel/tools/bread-crumb/interfaces/bread-crumb-item.interface";
import { computed, Signal } from "@angular/core";
import { StockTypeRoutePaths } from "@app/applications/stock/domains/stock-type/stock-type-route-paths";

export const baseBreadCrumb: IBreadCrumbItem[] = [
  {
    label: "SIDE_NAV.SETTINGS.TITLE",
  },
  {
    label: "SIDE_NAV.OTHER_SETTINGS",
  },
  {
    label: "STOCK_TYPE.TITLES.STOCK_TYPE",
    routerLink: StockTypeRoutePaths.ROOT,
  },
];

export const createBreadCrumb: IBreadCrumbItem[] = [
  ...baseBreadCrumb,
  {
    label: "BREAD_CRUMB.CREATE",
    active: true,
  },
];

export const updateBreadCrumb = (entity: Signal<{ id: string }>) =>
  computed<IBreadCrumbItem[]>(() => [
    ...baseBreadCrumb,
    {
      label: entity().id.slice(-6).toUpperCase(),
      routerLink: StockTypeRoutePaths.view(entity().id),
    },
    {
      label: "BREAD_CRUMB.EDIT",
      routerLink: StockTypeRoutePaths.edit(entity().id),
    },
  ]);

export const viewBreadCrumb = (entity: Signal<{ id: string }>) =>
  computed<IBreadCrumbItem[]>(() => [
    ...baseBreadCrumb,
    {
      label: entity().id.slice(-6).toUpperCase(),
      routerLink: StockTypeRoutePaths.view(entity().id),
    },
  ]);
